import { PageContainer } from '@components/PageContainer';
import {
	CalendarHolidaysIcon,
	HelpIcon,
	LinkItem,
	List,
	PinIcon,
	ShieldIcon,
	SupportIcon,
	TargetIcon,
} from '@gurupay/gp-ui-library';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface SupportItem {
	descriptionKey: string;
	linkKey: string;
	titleKey: string;
	icon: ReactElement;
}

const supportList: SupportItem[] = [
	{
		descriptionKey: 'support.helpDescription',
		linkKey: 'support.helpLink',
		titleKey: 'support.help',
		icon: <HelpIcon />,
	},
	{
		descriptionKey: 'support.faqDescription',
		linkKey: 'support.faqLink',
		titleKey: 'support.faq',
		icon: <TargetIcon />,
	},
	{
		descriptionKey: 'support.contactsDescription',
		linkKey: 'support.contactsLink',
		titleKey: 'support.contacts',
		icon: <PinIcon />,
	},
	{
		descriptionKey: 'support.bankHolidaysDescription',
		linkKey: 'support.bankHolidaysLink',
		titleKey: 'support.bankHolidays',
		icon: <CalendarHolidaysIcon />,
	},
	{
		descriptionKey: 'support.restrictionsDescription',
		linkKey: 'support.restrictionsLink',
		titleKey: 'support.restrictions',
		icon: <ShieldIcon />,
	},
];

export const Support = () => {
	const { t } = useTranslation();

	return (
		<PageContainer icon={<SupportIcon />} title={t('support.title')}>
			<List className="m-auto max-w-[512px]">
				{supportList.map((item) => (
					<LinkItem
						key={item.titleKey}
						description={t(item.descriptionKey)}
						icon={item.icon}
						isNewTab
						link={t(item.linkKey)}
						title={t(item.titleKey)}
					/>
				))}
			</List>
		</PageContainer>
	);
};
